export default "__VITE_ASSET__CCK7qXcp__"